// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","container":"g3bobya","label":"_2xNaNd0"};